export default "__VITE_ASSET__0mBN8Eid__"